import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Button,
  Input,
} from "reactstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import AdvertisersService from "../../../services/OrderingServices/AdvertisersService";

const AdvertiserStatsFilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
}) => {
  const [advertiserOptions, setAdvertiserOptions] = useState([]);
  const [loadingAdvertisers, setLoadingAdvertisers] = useState(false);

  // Fetch advertisers on component mount
  useEffect(() => {
    fetchAdvertisers();
  }, []);

  const fetchAdvertisers = async () => {
    try {
      setLoadingAdvertisers(true);
      const response = await AdvertisersService.advertisersList({
        page: 1,
        pageSize: 1000, // Fetch all advertisers
      });

      // Handle both array directly and object with data property
      const advertisersList = Array.isArray(response)
        ? response
        : response?.data || [];

      if (advertisersList && advertisersList.length > 0) {
        const options = advertisersList.map((advertiser) => ({
          value: advertiser.id,
          label: advertiser.advertiserName || advertiser.name,
        }));
        setAdvertiserOptions(options);
      }
    } catch (error) {
      console.error("Error fetching advertisers:", error);
    } finally {
      setLoadingAdvertisers(false);
    }
  };

  const handleAdvertiserChange = (selectedOption) => {
    handleFilterChange(
      "advertiserId",
      selectedOption ? selectedOption.value : "",
    );
  };

  return (
    <>
      <Row className="">
        <Col lg="12">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-light">
              <Row className="align-items-center justify-content-between w-100">
                <Col md="auto">
                  <h5 className="mb-0 d-flex align-items-center gap-2">
                    <i className="bx bx-filter-alt"></i> Search & Filter
                  </h5>
                </Col>

                <Col md="auto" className="d-flex gap-2">
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={handleClearFilters}
                  >
                    <i className="bx bx-reset me-2"></i>Clear All
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <Row className="g-3">
                {/* Advertiser Name Dropdown */}
                <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Advertiser
                    </Label>
                    <Select
                      options={advertiserOptions}
                      value={
                        filters.advertiserId
                          ? advertiserOptions.find(
                              (option) =>
                                option.value === filters.advertiserId,
                            )
                          : null
                      }
                      onChange={handleAdvertiserChange}
                      placeholder="Choose an advertiser..."
                      isClearable
                      isLoading={loadingAdvertisers}
                      classNamePrefix="react-select"
                    />
                  </FormGroup>
                </Col>

                {/* Date Range */}
                <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Start Date - End Date
                    </Label>

                    <div style={{ position: "relative", zIndex: 10 }}>
                      <Flatpickr
                        value={[filters.startDate, filters.endDate]}
                        onChange={(dates) => {
                          if (dates.length === 2) {
                            handleFilterChange("startDate", dates[0]);
                            handleFilterChange("endDate", dates[1]);
                          }
                        }}
                        options={{
                          mode: "range",
                          enableTime: true,
                          dateFormat: "Y-m-d H:i",
                          closeOnSelect: false,
                        }}
                        className="form-control form-control-md w-100"
                        placeholder="Start - End Date"
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AdvertiserStatsFilterCard;
